import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Dropdown, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import userMenuNavItems from '../../../../constants/userMenuNavItems';
import { useAuth } from '../../../context';
import { getInitials } from '../../../../utils';

import Collapse from '../../../common/Collapse';
import LogoutModal from '../../../auth/LogoutModal';

function UserActions() {
  const [visible, setVisible] = useState(false);
  const [show, setShow] = useState(false);
  const { user } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const fullName = user.entity.full_name || `${user.entity.first_name} ${user.entity.surname}`;

  const handleHide = (logout) => {
    if (logout) navigate('/logout');
    setShow(false);
  };

  return (
    <>
      <Dropdown id="user-menu" className="user" as={Nav.Item} onToggle={() => setVisible(!visible)}>
        <Dropdown.Toggle id="user-menu-toggle" as={Nav.Link} className="text-nowrap text-center">
          <span className="border-start p-0 ps-4 user">
            {user.avatar ? (
              <img
                className="user-avatar rounded-circle me-0 me-md-2"
                src={user.avatar}
                alt={fullName}
                height="27"
              />
            ) : (
              <span className="bg-primary-accent rounded-1 p-2 text-xs me-0 me-md-2 text-info">
                {getInitials(fullName)}
              </span>
            )}
            <span className="d-none d-md-inline-block text-info">{fullName}</span>
          </span>
        </Dropdown.Toggle>
        <Collapse
          as={Dropdown.Menu}
          className="justify-content-end dropdown-menu-small"
          show={visible}
        >
          {userMenuNavItems.map((item, index) => (
            <Dropdown.Item
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className={item.classes || undefined}
              as={item.to ? Link : undefined}
              to={item.to ? { pathname: item.to, state: { from: location.pathname } } : undefined}
              href={item.href || undefined}
              target={item.href ? '_blank' : undefined}
            >
              {item.iconClass && (
                <span className="d-inline-block item-icon-wrapper me-2">
                  <i className={item.iconClass} />
                </span>
              )}
              {item.title && <span>{t(item.title)}</span>}
            </Dropdown.Item>
          ))}
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => setShow(true)} className="text-danger">
            <i className="fas fa-sign-out-alt text-danger me-2" /> {t('user.menu.logout')}
          </Dropdown.Item>
        </Collapse>
      </Dropdown>
      <LogoutModal show={show} onHide={handleHide} />
    </>
  );
}

export default UserActions;
